import React, { useEffect, useState } from 'react';
import { getUserAttributes } from '@mb/lib';
import { ThemeProvider } from '@mui/material';
import { NylasSchedulerEditor } from '@nylas/react';
import { IntlProvider } from 'react-intl';
import { theme } from 'theme';
import { SchedulerWrapper } from './Scheduler.styles';
import { getCalendarLink } from '../../api/configurations';
import {
  getLocaleData,
  getNylasEditorConfig,
  getNylasGrant,
  saveCalendarLink,
} from '../../helpers';

export const SchedulerEditor = () => {
  const nylasEditorConfig = getNylasEditorConfig();
  const customerData = getUserAttributes();
  const [configurationId, setConfigurationId] = useState('');
  const [langData, setLangData] = useState({
    currentLocale: 'en',
    messages: {},
  });

  useEffect(() => {
    handleLangData();
  }, []);

  useEffect(() => {
    const urlParts = customerData?.calendar_link.split('/');
    if (urlParts?.length > 0) {
      setConfigurationId(urlParts[urlParts?.length - 1] ?? '');
    }
  }, [customerData?.calendar_link]);

  const handleLangData = async () => {
    const data = await getLocaleData();
    setLangData(data);
  };

  if (!langData) {
    return null;
  }

  return (
    <IntlProvider
      messages={langData.messages}
      locale={langData.currentLocale}
      defaultLocale="en"
    >
      <ThemeProvider theme={theme}>
        <SchedulerWrapper className={'mt-5'}>
          <NylasSchedulerEditor
            configurationId={configurationId}
            schedulerPreviewLink={`${window.location.origin}/calendar/{config.id}`}
            nylasSessionsConfig={nylasEditorConfig}
            enableUserFeedback={false}
            defaultSchedulerConfigState={{
              selectedConfiguration: {
                requires_session_auth: false,
              },
            }}
            eventOverrides={{
              initListConfigurations: async () => {
                const grant = getNylasGrant();
                if (!customerData?.calendar_link) {
                  const calendarLink = await getCalendarLink(
                    grant?.grant_id,
                    grant?.email,
                  );
                  if (calendarLink) {
                    saveCalendarLink(calendarLink);
                  }
                }
              },
            }}
          ></NylasSchedulerEditor>
        </SchedulerWrapper>
      </ThemeProvider>
    </IntlProvider>
  );
};
